import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cce38864"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "overlay-right" }
const _hoisted_3 = { class: "overlay-right-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold"} }, "项目资质要求", -1))
const _hoisted_5 = { class: "overlay-right-main" }
const _hoisted_6 = { class: "overlay-right-main__reuqire" }
const _hoisted_7 = { class: "overlay-right-main__info" }
const _hoisted_8 = { style: {"width":"100%","border":"1px solid #f0f0f0","text-align":"center"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { style: {"background":"#f0f0f0"} }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50%","border-right":"1px solid #f0f0f0"} }, " 姓名 "),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50%"} }, "手机号")
  ])
], -1))
const _hoisted_10 = { style: {"width":"50%","border-right":"1px solid #f0f0f0","border-top":"1px solid #f0f0f0"} }
const _hoisted_11 = { style: {"width":"50%","border-top":"1px solid #f0f0f0"} }
const _hoisted_12 = { class: "overlay-right-main__check" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin":"24px 0"} }, "终端服务人员已上传，点击查看", -1))
const _hoisted_14 = { class: "overlay-right-footer" }
const _hoisted_15 = { class: "overlay-left" }

import {
  withDefaults,
  watch,
  ref,
  nextTick,
  computed
} from 'vue';
import { BaseSvg } from '@/components/base/base-svg/index';
import BaseInsert from './base-insert.vue';
import {
  BaseButton,
  BaseImageViewer,
  BaseRadioGroup,
  BaseRadio,
  createDialog
} from 'xrk-components';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { projectQualificationsInfo } from '../data-source/apis';
import { auditQua } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'qualifications-audit',
  props: {
    id: { default: null },
    canAudit: { type: Boolean, default: false }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);

const props = __props;

const body = document.body;

const imgViewerShow = ref(true);
const showIndex = ref(0);

const baseInsertRef = ref();

const auditId = ref(props.id);
const onAudit = async status => {
  if (!status) {
    createDialog({
      title: '审核不通过',
      width: 370,
      contentRender: () => {
        return (
          <>
            <BaseInsert
              labelPosition={'left'}
              ruleValidator={(rule: any, value: any, callback: any) => {
                if (value === '') {
                  return callback(new Error('请填写不通过原因，最少5个字'));
                } else if (value.length < 5) {
                  return callback(new Error('请填写不通过原因，最少5个字'));
                } else {
                  callback();
                }
              }}
              label={''}
              placeholder={'请填写不通过原因，最少5个字'}
              maxlength={150}
              show-word-limit={true}
              type="textarea"
              rows={8}
              ref={baseInsertRef}
            ></BaseInsert>
          </>
        );
      },
      async beforeConfirm(done) {
        const { data } = await baseInsertRef.value.getFormData();
        const { data: nextId } = await auditQua({
          projectId: projectInfo.value.id,
          userId: [auditId.value],
          auditStatus: 3,
          auditOpinion: data,
          auditType: 1
        });
        if (!nextId) {
          done();
          onClose();
          return;
        }
        auditId.value = nextId;
        init(nextId);
      }
    });
  } else {
    createDialog({
      width: 350,
      title: '提示',
      content: `是否确认通过，请谨慎操作`,
      beforeConfirm: async done => {
        const { data: nextId } = await auditQua({
          projectId: projectInfo.value.id,
          userId: [auditId.value],
          auditStatus: 2,
          auditType: 1
        });
        if (!nextId) {
          done();
          onClose();
          return;
        }
        auditId.value = nextId;
        init(nextId);
      }
    });
  }
};

const picList = ref([]); //图片列表

const requireList = ref([]);
const personInfo = ref({
  name: '',
  phone: null
});

const quaDetail = ref([]);

const init = async (nextId?: number) => {
  const { data } = await projectQualificationsInfo({
    userId: nextId || props.id,
    projectId: projectInfo.value.id
  });
  requireList.value = data.projectQualifications;
  personInfo.value = {
    name: data.name,
    phone: data.phone
  };
  quaDetail.value = data.projectQualificationsDetail;

  picList.value = quaDetail.value[
    showIndex.value
  ].projectQualificationsAttachment.map(item => item.attachmentUrl);
  if (!data.projectQualificationsDetail.length) {
    imgViewerShow.value = false;
  }
};
init();

watch(
  () => showIndex.value,
  v => {
    imgViewerShow.value = false;
    picList.value = quaDetail.value[v].projectQualificationsAttachment.map(
      item => item.attachmentUrl
    );
    nextTick(() => {
      imgViewerShow.value = true;
    });
  }
);

const emits = __emit;

const onClose = () => {
  emits('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Teleport, { to: _unref(body) }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              onClick: onClose,
              style: {"cursor":"pointer"}
            }, [
              _createVNode(_unref(BaseSvg), {
                style: {"width":"20px","height":"20px"},
                iconClass: "close"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requireList.value, (item) => {
                return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(personInfo.value.name), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(personInfo.value.phone), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", null, [
                _createVNode(_unref(BaseRadioGroup), {
                  modelValue: showIndex.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showIndex).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quaDetail.value, (item, index) => {
                      return (_openBlock(), _createBlock(_unref(BaseRadio), {
                        key: item.qualificationsName,
                        value: index,
                        style: {"margin":"5px"},
                        size: "large",
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.qualificationsName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, [
              _createVNode(_unref(BaseButton), {
                disabled: !_ctx.canAudit,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onAudit(1))),
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 通过 ")
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_unref(BaseButton), {
                disabled: !_ctx.canAudit,
                type: "default",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onAudit(0))),
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 不通过 ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          (imgViewerShow.value)
            ? (_openBlock(), _createBlock(_unref(BaseImageViewer), {
                key: 0,
                infinite: true,
                "preview-src-list": picList.value,
                "hide-close": true
              }, null, 8, ["preview-src-list"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 8, ["to"]))
  ]))
}
}

})